import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './styling/admin.css';
import './styling/fonts.css';
import './styling/client.css';
import './styling/global.css';

if (typeof document !== 'undefined') {
  const preventImageContextMenu = (event) => {
    if (event.target?.tagName === 'IMG') {
      event.preventDefault();
    }
  };

  const preventImageDrag = (event) => {
    if (event.target?.tagName === 'IMG') {
      event.preventDefault();
    }
  };

  document.addEventListener('contextmenu', preventImageContextMenu);
  document.addEventListener('dragstart', preventImageDrag);
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);
